// Фальшивый модуль для rools
// rools для оптимизации распознает функции when по md5(f.toString()) и не вызывает второй раз те, что считает одинаковыми. 
// Этот модуль делает для него все используемые функции разными

(function(){
  module.exports = function (message, options) {
    return Math.random()
  };
})();
